import './index.scss';
import Sidebar from '../Sidebar';
import { Outlet } from 'react-router-dom';


const Layout = () => {

return ( 
<div className='App'>
    <Sidebar/>
    <div className='page'>
        <span id="top-tags" className='tags top-tags'>&lt;body&gt;</span>

        <Outlet/>
        <span id="bottom-tags" className='tags bottom-tags'>
        &lt;/body&gt;
        <br/>
        <span id="bottom-tag-html" className='bottom-tag-html'>&lt;/html&gt;</span>
        </span>
    </div>
</div>

)
}

export default Layout;